module.exports = __webpack_public_path__ + "images/home-dingtalk-work/howto_3-3044464f2715ed04586a49421bcb56a2.png";